/**
 * Tu Radar — Thought prompts by category.
 * Each category has 7 prompts. The system picks 4 per day.
 */

const thoughtPrompts = {
  identidad: [
    '¿Quién eres cuando nadie te está viendo? Descríbete sin títulos ni roles.',
    '¿Qué hacías de niño que te hacía perder la noción del tiempo?',
    '¿Qué valores no negociarías jamás en tu vida profesional?',
    'Si pudieras ser conocido por UNA cosa, ¿cuál sería?',
    '¿Qué problema del mundo te duele personalmente?',
    '¿Qué harías si supieras que no puedes fallar?',
    '¿Cuál es la diferencia entre lo que haces hoy y lo que realmente quieres hacer?',
  ],
  vision: [
    'Describe un martes ordinario en tu vida ideal dentro de 3 años.',
    '¿Cuánto dinero necesitas al mes para vivir como quieres? Sé específico.',
    '¿Dónde quieres trabajar: oficina, casa, cafetería, playa, van?',
    '¿Quieres un equipo grande o prefieres ser solo tú (y tal vez 1-2 personas)?',
    '¿Qué estilo de vida admiras? ¿De quién y por qué?',
    'Si tu negocio funcionara perfecto, ¿qué estarías haciendo tú día a día?',
    '¿Prefieres ingresos predecibles cada mes o golpes grandes pero irregulares?',
  ],
  miedo: [
    '¿Cuál es tu miedo más grande sobre emprender? Escríbelo sin filtro.',
    '¿Qué es lo peor que podría pasar si fallas? ¿Realmente es tan malo?',
    '¿Qué excusa te repites más seguido para no empezar?',
    '¿Hay alguien cuya opinión te frena? ¿Quién y por qué?',
    '¿Qué pasaría si sigues exactamente igual dentro de 5 años?',
    '¿Cuántas veces has empezado algo y lo dejaste? ¿Qué patrón ves?',
    '¿Qué necesitas soltar para avanzar?',
  ],
  accion: [
    '¿Cuál es la acción más pequeña que podrías hacer HOY hacia tu proyecto?',
    '¿Qué recurso ya tienes que no estás usando? (tiempo, habilidad, contacto)',
    'Si tuvieras que ganar $100 USD esta semana con tus habilidades, ¿cómo lo harías?',
    '¿A quién podrías pedir ayuda hoy que no le has pedido?',
    '¿Qué tarea has estado posponiendo y por qué?',
    'Escribe tu plan de acción para los próximos 7 días en 3 bullets.',
    '¿Qué herramienta o plataforma necesitas aprender para avanzar?',
  ],
  skill: [
    '¿En qué eres tan bueno que la gente te pide ayuda sin que cobres?',
    '¿Qué habilidad te falta que, si la tuvieras, cambiaría todo?',
    '¿Qué sabes hacer que la mayoría de la gente no?',
    '¿Cuál es tu combinación única de habilidades? (la intersección)',
    '¿Qué podrías enseñarle a alguien en 1 hora?',
    '¿Qué feedback positivo recibes más seguido de jefes, clientes o amigos?',
    '¿Hay algo que haces por hobby que podría ser un negocio?',
  ],
};

export default thoughtPrompts;
